<div class="  carousel-container  " *ngIf="load && companies && companies.length > 0">
    <div class="stores-carousel">
        <button type="button" class="btn btn-control prev" (click)="direction.isRTL() ? carousel.next() : carousel.prev()"><mat-icon>chevron_left</mat-icon></button>
        <button type="button" class="btn btn-control next" (click)="direction.isRTL() ? carousel.prev() : carousel.next()"><mat-icon>chevron_right</mat-icon></button>

        <owl-carousel-o [options]="carouselOptions" appOwlPreventClick #carousel>
            <ng-template *ngFor="let company of companies" carouselSlide>
                <div class="vendor-block">
                    <a class="vendor-block-image" appClick [routerLink]="((sector) ? ['/sector', sector] : ['/']).concat(['vendor', company.seo?.slug])">
                        <img [src]="company?.design?.logo?.url" loading="lazy">
                    </a>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div>